import React, { useContext, useState, useEffect } from "react";
import { ProductsContext } from "../../../../utils/stateHandlers/contexts";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import _ from "lodash";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function Quantity(props) {
  const { productState, productDispatch } = useContext(ProductsContext);
  const { priceLoaded, productInfo, style, validationErrors } = productState;
  const [localInput, setLocalInput] = useState(
    props.field.default === 0 ? 1 : props.field.default
  );
  const [localUnit, setLocalUnit] = useState(props.field.default_unit);
  const field = props.field;

  const handleInputChange = (e) => {
    setLocalInput(e.target.value);
    if (localUnit === "EA" && !_.isInteger(_.toNumber(e.target.value))) {
      productDispatch({
        type: "setValidationErrors",
        payload: [...validationErrors, "quantity"],
      });
    } else {
      const remove = _.remove(validationErrors, "dimension");
      productDispatch({ type: "setValidationErrors", payload: remove });
    }
  };

  const handleUnitInputChange = (e) => {
    setLocalUnit(e.target.value);
    if (e.target.value === "EA" && !_.isInteger(_.toNumber(localInput))) {
      productDispatch({
        type: "setValidationErrors",
        payload: [...validationErrors, "quantity"],
      });
    } else {
      const remove = _.remove(validationErrors, "dimension");
      productDispatch({ type: "setValidationErrors", payload: remove });
    }
  };

  useEffect(() => {
    if (localInput !== props.field.default) {
      const timeoutId = setTimeout(
        () =>
          productDispatch({
            type: "updateFields",
            field: field.name,
            payload: localInput,
          }),
        1000
      );
      return () => clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localInput]);

  useEffect(() => {
    if (localUnit !== productInfo.quantity_unit) {
      productDispatch({
        type: "updateFields",
        field: "quantity_unit",
        payload: localUnit,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localUnit]);

  useEffect(() => {
    //setLocalInput(field.default);
    if (style === "SD") {
      setLocalUnit(field.default_unit);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field]);

  useEffect(() => {
    if (_.startsWith(style, "CHM")) {
      setLocalInput(field.default);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [style]);

  return (
    <Grid container key={field.name}>
      <Grid item xs={8}>
        <Stack>
          <FormControl>
            <Typography
              sx={{
                fontWeight: "700",
                paddingBottom: ".3rem",
              }}
            >
              Quantity
            </Typography>
            <TextField
              color="primary"
              error={
                localUnit === "EA" && !_.isInteger(_.toNumber(localInput))
                  ? true
                  : false
              }
              disabled={!priceLoaded}
              onChange={(e) => {
                handleInputChange(e);
              }}
              size="small"
              sx={{
                width: "100%",
                margin: "unset",
              }}
              value={localInput}
            />
            <FormHelperText>
              {localUnit === "EA" && !_.isInteger(_.toNumber(localInput))
                ? "Please Enter A Whole Number."
                : ""}
            </FormHelperText>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={3}>
        <Stack>
          <Typography
            sx={{
              fontWeight: "700",
              paddingBottom: ".3rem",
            }}
          >
            Units
          </Typography>
          <Select
            value={localUnit === null ? field.default_unit : localUnit}
            sx={{ width: "100%" }}
            size="small"
            disabled={!priceLoaded || (field.units && field.units.length === 1)}
            onChange={(e) => {
              productDispatch({
                type: "updateFields",
                field: "quantity_unit",
                payload: e.target.value,
              });
              handleUnitInputChange(e);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #939598",
                  borderRadius: "0",
                  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                },
              },
            }}
          >
            <MenuItem value="None">
              <em>Select...</em>
            </MenuItem>
            {field.units &&
              field.units.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
          </Select>
        </Stack>
      </Grid>
    </Grid>
  );
}
